import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";
import { Observable } from "rxjs";
import { config } from "@config/config";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class ValidateOrderService extends BaseService {

  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  public validateOrder(formData: any, matriculas: string, center: string): Observable<any> {
      // Validar pedido
      return this.checkOrderNumber(
        formData.nTransporte.value,
        center, // by paramas "MY01"
        formData.dniConductor.value,
        formData.nombreConductor.value,
        formData.movilConductor.value,
        matriculas
      );
    }

  private  checkOrderNumber(pedido: string, centro:string, dniConductor:string,nombreConductor:string, movilConductor:string, matriculas: string): Observable<any> {
    const data =  {
      pedido,
      centro,
      dniConductor,
      nombreConductor,
      movilConductor,
      matriculas
    }

    const url = this.getUrl() + '/ws-samca/validate-order-data'
    return this.http.post( url, data, {headers: new HttpHeaders().set("Content-Type", "application/json")})
  }
  
}